import type { Module } from '@efdigital/ll-addon-data';
import { findModuleWithContent } from '@efdigital/ll-admin-v2/data/builders/xceed/modules';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { ProgramsProgramCohortModel } from '../../cohort.ts';

export type ParamsModuleId = {
  module_id: string;
};

export type ProgramsProgramCohortContentModuleModel =
  ProgramsProgramCohortModel &
    ParamsModuleId & {
      module: Module;
    };

export default class ProgramsProgramCohortContentModuleRoute extends Route<ProgramsProgramCohortContentModuleModel> {
  @service declare store: Store;

  async model(params: ParamsModuleId) {
    return {
      ...(this.modelFor(
        'programs.program.cohort'
      ) as ProgramsProgramCohortModel),
      ...params,
      module: (
        await this.store.request(findModuleWithContent(params.module_id))
      ).content.data,
    };
  }
}
